import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const getModalBalanceSlice = createSlice({
  name: "getModalBalance",
  initialState,
  reducers: {
    openModal: (state, action) => {
      const itemId = action.payload;
      state[itemId] = true;
    },
    closeModal: (state, action) => {
      const itemId = action.payload;
      state[itemId] = false;
    },
  },
});

export const { openModal, closeModal } = getModalBalanceSlice.actions;

export default getModalBalanceSlice.reducer;